import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { bodyTypesData, fuelTypesData, transmissionTypeData } from "@cinch-nx/data-search";
export var hydrate = function(data, type) {
    return data.map(function(param) {
        var label = param.label, value = param.value;
        return {
            label: "".concat(label, " cars"),
            value: value,
            searchValue: label.toLowerCase(),
            type: type
        };
    });
};
var LocalSearchData = _to_consumable_array(hydrate(fuelTypesData, "fuelType")).concat(_to_consumable_array(hydrate(bodyTypesData, "bodyType")), _to_consumable_array(hydrate(transmissionTypeData, "gearbox")));
export default LocalSearchData;
